import store from '../store'

export default async (to, from, next) => {
    const user = store.getters['auth/user'];

    if (user.hasRoles(['admin'])) {
        next();
    } else {
        next('/403');
    }
}